export default __webpack_public_path__ + "static/header-bg-d9fe079c853f727b8e73a5af53cb8ea9.png";